import { create } from 'zustand'
import { authApi } from '../api'

export const useAuthStore = create((set, get) => ({
  // DIQQAT: localStorage'dagi crt_user keshidan olingan rol/ruxsatlar faqat
  // taxminiy (advisory) hisoblanadi — UI ko'rinishi uchungina ishlatiladi va
  // har doim serverdan (getMe/refreshUser) qayta tekshirilishi shart.
  // (Cookie'ga ko'chirish keyinroq alohida qilinadi.)
  user: authApi.getCachedUser(),
  loading: false,
  error: null,

  login: async (username, password, totpCode = null) => {
    set({ loading: true, error: null })
    try {
      const data = await authApi.login(username, password, totpCode)
      set({ user: data.user, loading: false })
      return { success: true, needsTotp: false }
    } catch (err) {
      const msg = err.message || 'Xatolik'
      if (msg.includes('2FA') || msg.includes('TOTP') || msg.includes('totp')) {
        set({ loading: false, error: null })
        return { success: false, needsTotp: true }
      }
      set({ loading: false, error: msg })
      return { success: false, needsTotp: false }
    }
  },

  logout: () => authApi.logout(),

  updateUser: (partial) => {
    const updated = { ...get().user, ...partial }
    localStorage.setItem('crt_user', JSON.stringify(updated))
    set({ user: updated })
  },

  refreshUser: async () => {
    try {
      const user = await authApi.getMe()
      localStorage.setItem('crt_user', JSON.stringify(user))
      set({ user })
    } catch {}
  },

  isSuperAdmin: () => get().user?.role === 'super_admin',
  isOperator: () => get().user?.role === 'operator',

  // task 1 — ruxsat tekshirish (super_admin doim true)
  hasPermission: (perm) => {
    const u = get().user
    if (!u) return false
    if (u.role === 'super_admin') return true
    return Array.isArray(u.permissions) && u.permissions.includes(perm)
  },
}))

export const useStore = create((set) => ({
  theme: localStorage.getItem('crt_theme') || 'light',
  sidebarCollapsed: false,
  // Tor ekranda yon panel oqimdan chiqib, chetdan chiqadigan panelga aylanadi.
  // `sidebarCollapsed` dan ALOHIDA holat: yig'ish — kengligi haqida, bu esa
  // ochiq/yopiqligi haqida. Ikkalasini bitta bayroqqa yig'ish telefondan
  // kompyuterga o'tganda panelni kutilmaganda yig'ib qo'yardi.
  mobileNavOpen: false,
  notifOpen: false,

  // SOS kritik ogohlantirishlar
  sosAlerts: [],
  addSosAlert:   (alert) => set(s => ({ sosAlerts: [alert, ...s.sosAlerts].slice(0, 20) })),
  clearSosAlert: (id)    => set(s => ({ sosAlerts: s.sosAlerts.filter(a => a.id !== id) })),
  clearAllSos:   ()      => set({ sosAlerts: [] }),
  // Kritik panel reload trigger
  criticalKey: 0,
  triggerCriticalReload: () => set(s => ({ criticalKey: s.criticalKey + 1 })),

  // Real-time xarita markeri (MapPage uchun)
  liveMapEvent: null,
  setLiveMapEvent: (ev) => set({ liveMapEvent: ev }),
  clearLiveMapEvent: () => set({ liveMapEvent: null }),

  toggleTheme: () =>
    set((s) => {
      const next = s.theme === 'light' ? 'dark' : 'light'
      document.documentElement.setAttribute('data-theme', next)
      localStorage.setItem('crt_theme', next)
      return { theme: next }
    }),

  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setSidebarCollapsed: (val) => set({ sidebarCollapsed: val }),
  toggleMobileNav: () => set((s) => ({ mobileNavOpen: !s.mobileNavOpen })),
  setMobileNav: (val) => set({ mobileNavOpen: val }),
  toggleNotif: () => set((s) => ({ notifOpen: !s.notifOpen })),
  closeNotif: () => set({ notifOpen: false }),

  // Split Panel State
  splitPage: (() => {
    const s = localStorage.getItem('split_page')
    return s || null
  })(),
  setSplitPage: (page) => set(() => {
    if (page) {
      localStorage.setItem('split_page', page)
    } else {
      localStorage.removeItem('split_page')
    }
    return { splitPage: page }
  }),

  // Toastlar (global xabarnomalar)
  toasts: [],
  addToast: (text, type = 'default') => {
    const id = Date.now() + Math.random();
    set(s => ({ toasts: [...s.toasts, { id, text, type }] }));
    setTimeout(() => {
      set(s => ({ toasts: s.toasts.filter(t => t.id !== id) }));
    }, 5000);
  },
  removeToast: (id) => set(s => ({ toasts: s.toasts.filter(t => t.id !== id) })),

  // Real-time yangi murojaatlar (Dashboard kartasi uchun)
  newTickets: [],
  addNewTicket: (ticket) => set(s => {
    const exists = s.newTickets.some(t => t.ticket_number === ticket.ticket_number)
    if (exists) return {}
    return { newTickets: [ticket, ...s.newTickets].slice(0, 10) }
  }),
  removeNewTicket: (ticket_number) => set(s => ({
    newTickets: s.newTickets.filter(t => t.ticket_number !== ticket_number)
  })),
  clearNewTickets: () => set({ newTickets: [] }),
}))

